import { combineEpics } from 'redux-observable';
import bankEpic$ from './bank/epics';
import handleEpic$ from './handle/epics';
import systemEpic$ from './system/epics';

export default combineEpics(bankEpic$, handleEpic$, systemEpic$);
